// extracted by mini-css-extract-plugin
export default {"Cart":"Cart_Cart__1UUPL","Cart__preview":"Cart_Cart__preview__2mfPl","Cart__amount":"Cart_Cart__amount__1mKPF"};